import { render, staticRenderFns } from "./ChagePwd.vue?vue&type=template&id=5b3f1d64"
import script from "./ChagePwd.vue?vue&type=script&lang=js"
export * from "./ChagePwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports